export default __webpack_public_path__ + "static/media/ele_Preson_3_2.2f5b1ed4.png";